var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripleArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.128.123a.44.44 0 01.61 0l2.136 2.099c.163.16.169.416.013.583L.783 4.872a.437.437 0 01-.418.114.427.427 0 01-.307-.3.417.417 0 01.114-.41l1.789-1.778L.128.72a.414.414 0 010-.597z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bec3e1",
    d: "M4.128.123a.44.44 0 01.61 0l2.136 2.099c.163.16.169.416.013.583L4.783 4.872a.437.437 0 01-.418.114.427.427 0 01-.307-.3.417.417 0 01.114-.41l1.789-1.778L4.128.72a.414.414 0 010-.597z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#454566",
    d: "M8.128.123a.44.44 0 01.61 0l2.136 2.099c.163.16.169.416.013.583L8.783 4.872a.437.437 0 01-.418.114.427.427 0 01-.307-.3.417.417 0 01.114-.41l1.789-1.778L8.128.72a.414.414 0 010-.597z"
  })));
}
export default __webpack_public_path__ + "static/svg/triple-arrows.svg";
export { SvgTripleArrows as ReactComponent };